import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { STATIC_ROOT } from '../../../constants';

import headerService from '../../../services/header';

import SvgComponent from '../../SvgComponent';
import LoggedInComponent from './LoggedInComponent';
import LoggedOutComponent from './LoggedOutComponent';
import { LoadingComponent } from '../../loading/LoadingComponent';

import './MemberNavComponent.scss';

class MemberNavComponent extends Component {
    onClickBtMenuMobile(e) {
        e.preventDefault();
        this.props.dispatch(
            headerService.actions.toggleMenuMobileSlide(
                headerService.constants.MEMBRE_VERSION_MENU_MOBILE_SLIDE
            )
        );
    }

    render() {
        const { i18n, isAuthenticated, fetching, user, urlConnection } = this.props;
        return (
            <div className="menu-membre flex-container-h flex-center-alt">
                {fetching ? (
                    <LoadingComponent />
                ) : (
                    <React.Fragment>
                        <div
                            className="menu-membre-ico curpt"
                            onClick={this.onClickBtMenuMobile.bind(this)}>
                            <SvgComponent
                                src={`${STATIC_ROOT}/picto-connexion.svg`}
                                width="17"
                                height="17"
                            />
                        </div>
                        {isAuthenticated ? (
                            <LoggedInComponent>
                                {user && user.firstname && user.lastname ? (
                                    <span className="menu-membre-name">{i18n.MY_ACCOUNT}</span>
                                ) : (
                                    i18n.SEE_MY_ACCOUNT
                                )}
                            </LoggedInComponent>
                        ) : (
                            <LoggedOutComponent urlConnection={urlConnection} />
                        )}
                    </React.Fragment>
                )}
            </div>
        );
    }
}

MemberNavComponent.propTypes = {
    user: PropTypes.object.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    fetching: PropTypes.bool.isRequired,
    urlConnection: PropTypes.string.isRequired,
    stateOpenMenuMobileSlide: PropTypes.bool.isRequired,
    versionOpenMenuMobileSlide: PropTypes.string.isRequired,
    i18n: PropTypes.object.isRequired
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {
        i18n: state.i18n.feature.header.MEMBER_NAV
    };
}

export default connect(mapStateToProps)(MemberNavComponent);



// WEBPACK FOOTER //
// ./src/components/header/membernav/MemberNavComponent.js